import { Box, Typography } from '@mui/material';

const companies = [
  {
    name: 'Meta',
    logo: 'https://commons.wikimedia.org/wiki/Special:Redirect/file/Meta%20Platforms%20Inc.%20logo%20%28cropped%29.svg',
    logoWidth: 34,
    logoHeight: 24,
  },
  {
    name: 'Instagram',
    logo: 'https://commons.wikimedia.org/wiki/Special:Redirect/file/Instagram%20Glyph%20Gradient%20RGB%20logo.svg',
    logoWidth: 28,
    logoHeight: 28,
  },
  {
    name: 'Salesforce',
    logo: 'https://commons.wikimedia.org/wiki/Special:Redirect/file/Salesforce.com%20logo.svg',
    logoWidth: 46,
    logoHeight: 32,
  },
  {
    name: 'Harvard',
    logo: 'https://commons.wikimedia.org/wiki/Special:Redirect/file/Harvard%20University%20shield.svg',
    logoWidth: 24,
    logoHeight: 30,
  },
  {
    name: 'MIT',
    logo: 'https://commons.wikimedia.org/wiki/Special:Redirect/file/MIT%20logo%202003-2023.svg',
    logoWidth: 42,
    logoHeight: 28,
  },
];

export default function CredentialLogos({ compact = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: 1.2, md: 1.6 },
        flexWrap: 'wrap',
      }}
    >
      {companies.map((company) => (
        <Box
          key={company.name}
          sx={{
            height: compact ? 48 : 52,
            minWidth: company.name === 'Salesforce' || company.name === 'Instagram' ? 154 : 132,
            px: 2,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.1,
            borderRadius: 999,
            bgcolor: '#fff',
            border: '1px solid',
            borderColor: 'rgba(10, 13, 20, 0.1)',
            boxShadow: compact ? 'none' : '0 14px 50px rgba(82, 107, 170, 0.08)',
          }}
        >
          <Box
            component="img"
            src={company.logo}
            alt={`${company.name} logo`}
            loading="lazy"
            sx={{
              width: company.logoWidth,
              height: company.logoHeight,
              display: 'block',
              flexShrink: 0,
              objectFit: 'contain',
              objectPosition: 'center',
            }}
          />
          <Typography
            component="span"
            sx={{
              color: '#172033',
              fontSize: company.name === 'Salesforce' || company.name === 'Instagram' ? '0.94rem' : '1rem',
              fontWeight: 850,
              lineHeight: 1,
              whiteSpace: 'nowrap',
            }}
          >
            {company.name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
